import { render, staticRenderFns } from "./demand-detail.vue?vue&type=template&id=74c096ce&scoped=true"
import script from "./demand-detail.vue?vue&type=script&lang=js"
export * from "./demand-detail.vue?vue&type=script&lang=js"
import style0 from "./demand-detail.vue?vue&type=style&index=0&id=74c096ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c096ce",
  null
  
)

export default component.exports